export type BinaryDownload = {
  readonly filename: string;
  readonly bytes: Uint8Array;
  readonly type: string;
};

export function downloadBinaryFile({ filename, bytes, type }: BinaryDownload): void {
  downloadBlob(filename, new Blob([new Uint8Array(bytes).buffer], { type }));
}

export function downloadTextFile({ filename, text, type = "text/csv;charset=utf-8" }: {
  readonly filename: string;
  readonly text: string;
  readonly type?: string;
}): void {
  downloadBlob(filename, new Blob([text], { type }));
}

function downloadBlob(filename: string, blob: Blob): void {
  const url = URL.createObjectURL(blob);
  const anchor = document.createElement("a");
  anchor.href = url;
  anchor.download = filename;
  anchor.style.display = "none";
  document.body.appendChild(anchor);
  anchor.click();
  anchor.remove();
  URL.revokeObjectURL(url);
}
